import { BoxProps, Text } from "@chakra-ui/react"
import { AlertBox } from "./AlertBox"
import { CWarning, CWarningOutline } from "./Icons"

type WarningAdditionalInformationsProps = {
  label: string
  variant?: "outline" | "solid"
} & BoxProps

const WarningAdditionalInformations = ({ label, variant = "solid", ...props }: WarningAdditionalInformationsProps) => {
  return (
    <AlertBox
      colorSide="warning"
      colorMain="warningTransparency10"
      icon={variant === "outline" ? <CWarningOutline color="white" /> : <CWarning color="white" />}
      {...props}
    >
      <Text>{label}</Text>
    </AlertBox>
  )
}

export default WarningAdditionalInformations
